export enum CouponType {
  SPECIAL = 'SPECIAL',
  COUPON = 'COUPON',
  LOYALTY = 'LOYALTY',
  OPTIONAL = 'OPTIONAL',
  PUNCHH = 'PUNCHH',
}
